module.exports = __webpack_public_path__ + "img/755-907208.png";